import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
//const authentication = require('react-azure-adb2c').default;
//import { Dispatch } from 'redux';
import moment from 'moment'

import { call, put, takeEvery, select } from 'redux-saga/effects';
// import * as RentContractMoniesApi from '../Api/RentContractMoniesApi.ts_';
// import * as RentContractAccountingApi from '../Api/RentContractAccountingApi.ts_';
import * as minories_api from '../Api/minories_api';
import * as bklist_api from '../Api/bklist_api';
import * as sokinlist_api from '../Api/sokinlist_api';
import * as shlist_api from '../Api/shlist_api';
import * as koumokulist_api from '../Api/koumokulist_api';


// import * as UsersApi from './Api/UsersApi';
// import * as RentAgentsApi from './Api/RentAgentsApi';
// import * as Kyousai from '../../Kyousai/Saga/Kyousai';
///types


//export interface HogeState {
//    responselist: string[];
//    responseedit: number;
//}
export interface State {
    // rent_contract_monies:any;
    minories: any;
    bklist: any;
    sokinlist: any;
    search: any;
    shlist: any;

    addky: any;
    delky: any;
    koumokulist: any;
    pre_sokinlist: any;

    // owner_remittance_check_logs_list: any;
    // owner_remittance_check_logs_sum: any;
    // so_ymd_list: any;

    // so_ymd_list_sum: any;
    // remittancelogcheck_search_form: any;
    // search_diff: any;
    // search_contract_date_start: any;
    // search_contract_date_end: any;
    // search_tatemono_name: any;
    // parking_check_loading: number;
    // net_check_loading: number;

    // energization_check_loading: number;

    // electronics_check_loading: number;
    // wifi_check_loading: number;
    // search_loading: boolean;
    // owner_tel_check_loading: number;
}
const initialState: State = {

    // rent_contract_monies: [],
    minories: [],
    bklist: [],
    sokinlist: [],
    shlist: [],
    search: {
        bk_no: null,
        date1: moment().add('month', -1).startOf('month').format("YYYY/MM/DD HH:mm:ss"),
        date2: moment().endOf('month').format("YYYY/MM/DD HH:mm:ss"),
    },
    addky: [],
    delky: [],
    koumokulist: [],
    pre_sokinlist: [],

    // owner_remittance_check_logs_list: [],
    // so_ymd_list: [],
    // so_ymd_list_sum: 0,
    // owner_remittance_check_logs_sum: 0,
    // search_diff: false,
    // remittancelogcheck_search_form: {
    //     so_ymd: '2020/6/20',
    //     // search_contract_date_start: null,
    //     // search_contract_date_end: null,
    //     // search_tatemono_name: null,
    //     // search_completed: false,
    // },
    // search_contract_date_start: null,
    // search_contract_date_end: null,
    // search_tatemono_name: "",

    // parking_check_loading: 0,
    // net_check_loading: 0,

    // energization_check_loading: 0,

    // electronics_check_loading: 0,
    // wifi_check_loading: 0,
    // search_loading: false,
    // owner_tel_check_loading: 0,

    // users: [],
    // rentAgents: [],
    // rentMReasons: [],



}



///action 
const actionCreator = actionCreatorFactory();

// export const get_rent_contract_monies = actionCreator<{rent_contract_id:number}>('GET_RENT_CONTRACT_MONIES');
// export const get_rent_contract_monies_success = actionCreator("GET_RENT_CONTRACT_MONIES_SUCCESS");
// export const get_rent_contract_monies_failure = actionCreator("GET_RENT_CONTRACT_MONIES_FAILURE");

// export const get_rent_contract_accounting = actionCreator("GET_RENT_CONTRACT_ACCOUNTING");
export const get_bklist = actionCreator<any>('GET_BKLIST');
export const change_bklist = actionCreator<any>('CHANGE_BKLIST');

export const get_sokinlist = actionCreator<any>('GET_SOKINLIST');
export const change_sokinlist = actionCreator<any>('CHANGE_SOKINLIST');

export const get_shlist = actionCreator<any>('GET_SHLIST');
export const change_shlist = actionCreator<any>('CHANGE_SHLIST');

export const get_remittance_details = actionCreator<any>('GET_REMITTANCE_DETAILS');
export const change_remittance_details = actionCreator("CHANGE_REMITTANCE_DETAILS");
// export const change_owner_remittance_check_logs_list = actionCreator("CHANGE_OWNER_REMITTANCE_CHECK_LOGS_LIST");

export const change_search = actionCreator<any>("CHANGE_SEARCH");

export const change_addky = actionCreator<any>("CHANGE_ADDKY");
export const change_delky = actionCreator<any>("CHANGE_DELKY");

export const get_koumokulist = actionCreator<any>("GET_KOUMOKULIST");
export const change_koumokulist = actionCreator<any>("CHANGE_KOUMOKULIST");

export const change_pre_sokinlist = actionCreator<any>("CHANGE_PRE_SOKINLIST");


// export const getRentMReasons = actionCreator('RENT_M_REASONS_REQUEST');
// export const getRentMReasonsSuccess = actionCreator("RENT_M_REASONS_SUCCESS");
// export const getRentMReasonsFailure = actionCreator("RENT_M_REASONS_FAILURE");


export const remittance_detail_Reducer = reducerWithInitialState(initialState)
    .case(change_remittance_details, (state, payload) => ({ ...state, minories: payload }))
    .case(change_bklist, (state, payload) => ({ ...state, bklist: payload }))
    .case(change_sokinlist, (state, payload) => ({ ...state, sokinlist: payload }))
    .case(change_shlist, (state, payload) => ({ ...state, shlist: payload }))
    .case(change_search, (state, payload) => ({ ...state, search: payload }))
    .case(change_addky, (state, payload) => ({ ...state, addky: payload }))
    .case(change_delky, (state, payload) => ({ ...state, delky: payload }))
    .case(change_koumokulist, (state, payload) => ({ ...state, koumokulist: payload }))
    .case(change_pre_sokinlist, (state, payload) => ({ ...state, pre_sokinlist: payload }))


// .case(change_remittancelogcheck_search_form, (state, payload) => ({ ...state, remittancelogcheck_search_form: payload }))

// .case(change_owner_remittance_check_logs_sum, (state, payload) => ({ ...state, owner_remittance_check_logs_sum: payload }))
// .case(change_so_ymd_list_sum, (state, payload) => ({ ...state, so_ymd_list_sum: payload }))
// .case(change_search_diff, (state, payload) => ({ ...state, search_diff: payload }))

// .case(change_owner_remittance_check_logs_list, (state, payload) => ({ ...state, owner_remittance_check_logs_list: payload }))






// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const remittance_detail_Saga = [
    //     takeEvery('GET_RENT_CONTRACT_MONIES', handleRequestMoney),
    // takeEvery('GET_RENT_CONTRACT_ACCOUNTING', handle_get_rent_contract_accounting),
    takeEvery('GET_REMITTANCE_DETAILS', handle_get_minories),

    takeEvery('GET_BKLIST', handle_get_bklist),

    takeEvery('GET_SOKINLIST', handle_get_sokinlist),

    takeEvery('GET_SHLIST', handle_get_shlist),

    takeEvery('GET_KOUMOKULIST', handle_get_koumokulist),

    // takeEvery('GET_SO_YMD_LIST', handle_get_so_ymd_list),

    // takeEvery('NET_CHECKED', handle_net_checked),

    // takeEvery('ENERGIZATION_CHECKED', handle_energization_checked),

    // takeEvery('ELECTRONICS_CHECKED', handle_electronics_checked),
    // takeEvery('WIFI_CHECKED', handle_wifi_checked),
    // // takeEvery('BIND_KYOUSAI_CONTRACT', handle_bind_kyousai_contract),

    // takeEvery('COMPLETED_CHECKED', handle_completed_checked),

    // takeEvery('ALL_SELECTED', handle_all_selected),

    // takeEvery('CHECK_COMPLETED', handle_check_completed),

    // takeEvery('CHECK_COMPLETED_CANCEL', handle_check_completed_cancel),

    // takeEvery('OWNER_TEL_CHECKED', handle_owner_tel_checked),

    // takeEvery('USERS_REQUEST', handleUsersRequest),
    // takeEvery('RENT_AGENTS_REQUEST', handleRentAgentsRequest),
    // takeEvery('RENT_M_REASONS_REQUEST', handleRentMReasonsRequest),
];
// export default masterSaga;


function* handle_get_bklist(action: any) {
    const state = yield select();

    // let search_form = state.ContractCheck.search_form
    // yield put(change_search_loading(true))

    // let search_id = state.kyousaiReducer.search_id
    const { payload, error } = yield call(bklist_api.list, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // console.log(payload)
        yield put(change_bklist(payload));
        // const { payload2, error2 } = yield call(sh_furi_api.list, {

    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}



function* handle_get_koumokulist(action: any) {
    const state = yield select();

    // let search_form = state.ContractCheck.search_form
    // yield put(change_search_loading(true))

    // let search_id = state.kyousaiReducer.search_id
    const { payload, error } = yield call(koumokulist_api.list, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // console.log(payload)


        let columns = []
        columns.push({ key: 'gt_ym', name: '請求月', width: 60, resizable: true })
        columns.push({ key: 'hy_no', name: '部屋名', width: 60, resizable: true })
        columns.push({ key: 'kys_name', name: '契約者名', width: 100, resizable: true })
        payload["at"].map(function (value: any) {
            if (value.nkin_no === "1010") {
                columns.push({
                    key: value.nkin_no + "_kou", name: value.nkin_name, width: 60, resizable: true
                })
            } else {
                columns.push({ key: value.nkin_no + "_kou", name: value.nkin_name, width: 60, resizable: true })
            }
        })
        payload["pre"].map(function (value: any) {
            if (!payload["at"].filter((a: any) => a.nkin_no === value.nkin_no)[0]) {
                if (value.nkin_no === "1010") {
                    columns.push({
                        key: value.nkin_no + "_kou", name: value.nkin_name, width: 60, resizable: true
                    })
                } else {
                    columns.push({ key: value.nkin_no + "_kou", name: value.nkin_name, width: 60, resizable: true })
                }
            }
        })

        columns.push({ key: "sosum", name: "合計", width: 90, resizable: true })
        columns.push({ key: "seed", name: "シード", width: 90, resizable: true })
        columns.push({ key: "minori", name: "みのり", width: 90, resizable: true })
        columns.push({ key: "biko", name: "備考", width: 90, resizable: true })
        console.log(columns)
        yield put(change_koumokulist(columns));
        // for (var i = 0; data.length > i; i++) {
        //     if (data[i]["nkin_no"] == "1010") {
        //         columns.push({ id: data[i]["nkin_no"] + "_S", name: data[i]["nkin_name"], field: data[i]["nkin_no"] + "_S", width: 90, sortable: true, headerCssClass: "orange", cssClass: "setmoney", formatter: ValueFormatter });
        //     } else {
        //         columns.push({ id: data[i]["nkin_no"] + "_S", name: data[i]["nkin_name"], field: data[i]["nkin_no"] + "_S", width: 70, sortable: true, headerCssClass: "orange", cssClass: "setmoney", formatter: ValueFormatter });

        //     }
        // }
        // columns.push({ id: "sosum", name: "合計", field: "sosum", width: 90, cssClass: "setmoney", sortable: true, formatter: ValueFormattersum })

        // columns.push({ id: "seed", name: "シード", field: "seed", width: 140, cssClass: "setmoney", headerCssClass: "pink", sortable: true, formatter: seedFormatter })
        // columns.push({ id: "minori", name: "みのり", field: "minori", width: 140, cssClass: "setmoney", headerCssClass: "pink", sortable: true, formatter: minoriFormatter })

        // columns.push({ id: "biko", name: "備考", field: "biko", width: 150, sortable: true })

    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}


function* handle_get_sokinlist(action: any) {
    const state = yield select();
    yield put(change_sokinlist([]));
    // let search_form = state.ContractCheck.search_form
    // yield put(change_search_loading(true))
    action.payload.so_yoteiymd = moment(action.payload.so_yoteiymd).format("YYYY-MM-DD");
    // yield put(get_koumokulist(action.payload));
    const { payload, error } = yield call(sokinlist_api.list, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)


        let columns: any = []

        columns.push({ key: 'gt_ym', name: '請求月', width: 60, resizable: true })
        columns.push({ key: 'hy_no', name: '部屋名', width: 60, resizable: true })
        columns.push({ key: 'kys_name', name: '契約者名', width: 100, resizable: true })
        payload["koumoku_at"].map(function (value: any) {
            if (value.nkin_no === "1010") {
                columns.push({
                    key: value.nkin_no + "_kou", name: value.nkin_name, width: 60, resizable: true
                })
            } else {
                columns.push({ key: value.nkin_no + "_kou", name: value.nkin_name, width: 60, resizable: true })
            }


        })
        payload["koumoku_pre"].map(function (value: any) {
            if (!payload["koumoku_at"].filter((a: any) => a.nkin_no === value.nkin_no)[0]) {
                if (value.nkin_no === "1010") {
                    columns.push({
                        key: value.nkin_no + "_kou", name: value.nkin_name, width: 60, resizable: true
                    })
                } else {
                    columns.push({ key: value.nkin_no + "_kou", name: value.nkin_name, width: 60, resizable: true })
                }
            }

        })

        columns.push({ key: "sosum", name: "合計", width: 90, resizable: true })
        columns.push({ key: "seed", name: "シード", width: 90, resizable: true })
        columns.push({ key: "minori", name: "みのり", width: 90, resizable: true })
        columns.push({ key: "biko", name: "備考", width: 90, resizable: true })
        console.log(columns)
        yield put(change_koumokulist(columns));













        var news: any = []
        let end = 0
        payload.at.map(async function (value: any) {
            payload["koumoku_at"].map(async function (kjoumoku_at_value: any) {
                value[kjoumoku_at_value.nkin_no + "_kou"] = kjoumoku_at_value.nkin_no + "_kou"

            })
            payload["koumoku_pre"].map(async function (kjoumoku_pre_value: any) {
                if (!payload["koumoku_at"].filter((a: any) => a.nkin_no === kjoumoku_pre_value.nkin_no)[0]) {
                    value[kjoumoku_pre_value.nkin_no + "_kou"] = kjoumoku_pre_value.nkin_no + "_kou"

                }
            })
            let add = 0
            if (value.kys_name === "※※収入合計※※①") {
                end = 1
            }
            if (end === 0) {



                let pres = payload.pre.map(async function (prevalue: any) {
                    if (value.hy_no === prevalue.hy_no && value.ky_no === prevalue.ky_no) {



                        columns.map(function (columnvalue: any) {
                            if (columnvalue.key.match(/_kou/)) {
                                if (prevalue[columnvalue.key.replace('_kou', '_S')] !== value[columnvalue.key.replace('_kou', '_S')]) {
                                    value[columnvalue.key.replace('_kou', '_check')] = true
                                } else {
                                    value[columnvalue.key.replace('_kou', '_check')] = false
                                }
                            }
                        })


                        // console.log(prevalue.hy_no)
                        // console.log(value.hy_no)
                        // console.log(prevalue.kys_name)
                        // console.log(value.kys_name)
                        add = 1
                        return prevalue
                    }
                })





                if (add === 0) {

                    news.push(value)
                }


            }



        })
        var dels: any = []
        end = 0
        payload.pre.map(async function (value: any) {
            let deleteset = 0
            if (value.kys_name === "※※収入合計※※①") {
                end = 1
            }
            if (end === 0) {
                let a = payload.at.map(async function (prevalue: any) {
                    if (value.hy_no === prevalue.hy_no && value.ky_no === prevalue.ky_no) {
                        // console.log(prevalue.hy_no)
                        // console.log(value.hy_no)
                        // console.log(prevalue.kys_name)
                        // console.log(value.kys_name)
                        deleteset = 1
                        return prevalue
                    }
                })
                if (deleteset === 0) {
                    value.del = true
                    payload["koumoku_at"].map(async function (kjoumoku_at_value: any) {
                        value[kjoumoku_at_value.nkin_no + "_kou"] = kjoumoku_at_value.nkin_no + "_kou"

                    })
                    payload["koumoku_pre"].map(async function (kjoumoku_pre_value: any) {
                        if (!payload["koumoku_at"].filter((a: any) => a.nkin_no === kjoumoku_pre_value.nkin_no)[0]) {
                            value[kjoumoku_pre_value.nkin_no + "_kou"] = kjoumoku_pre_value.nkin_no + "_kou"

                        }
                    })
                    dels.push(value)
                }


            }

        })
        yield put(change_addky(news));
        yield put(change_delky(dels));
        // alert(JSON.stringify(payload))
        // console.log(payload)
        const at = payload.at.map(function (value: any) {
            value.new = false
            value.del = false

            payload.pre.map(async function (prevalue: any) {
                if (value.hy_no === prevalue.hy_no && value.ky_no === prevalue.ky_no) {

                    columns.map(function (columnvalue: any) {
                        if (columnvalue.key.match(/_kou/)) {
                            if (prevalue[columnvalue.key.replace('_kou', '_S')] !== value[columnvalue.key.replace('_kou', '_S')]) {
                                value[columnvalue.key.replace('_kou', '_check')] = true
                            } else {
                                value[columnvalue.key.replace('_kou', '_check')] = false
                            }
                        }
                    })


                    // console.log(prevalue.hy_no)
                    // console.log(value.hy_no)
                    // console.log(prevalue.kys_name)
                    // console.log(value.kys_name)

                    return prevalue
                }
            })

            news.map(function (prevalue: any) {
                if (value.hy_no === prevalue.hy_no && value.ky_no === prevalue.ky_no) {
                    value.new = true
                }
            })
            return value
        })

        yield put(change_pre_sokinlist(payload.pre));
        console.log(at)

        yield put(change_sokinlist(dels.concat(at)));
        // const { payload2, error2 } = yield call(sh_furi_api.list, {

    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}


function* handle_get_shlist(action: any) {
    const state = yield select();

    // let search_form = state.ContractCheck.search_form
    // yield put(change_search_loading(true))
    let search = state.RemittanceDetail.search

    search.date1 = moment(search.date1).format("YYYY-MM-DD");
    search.date2 = moment(search.date2).format("YYYY-MM-DD");
    // let search_id = state.kyousaiReducer.search_id
    const { payload, error } = yield call(shlist_api.list, search);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // alert(JSON.stringify(payload))
        // console.log(payload)
        yield put(change_shlist(payload));
        // const { payload2, error2 } = yield call(sh_furi_api.list, {

    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}

function* handle_get_minories(action: any) {
    const state = yield select();

    // let search_form = state.ContractCheck.search_form
    // yield put(change_search_loading(true))

    // let search_id = state.kyousaiReducer.search_id
    const { payload, error } = yield call(minories_api.list, state.RemittanceLogCheck.remittancelogcheck_search_form);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // console.log(payload)
        yield put(change_remittance_details(payload));
        // const { payload2, error2 } = yield call(sh_furi_api.list, {
        //     so_ymd: state.RemittanceLogCheck.remittancelogcheck_search_form.so_ymd
        // });

        // // サーバーからのレスポンスデータによる分岐処理
        // if (payload2 && !error2) {
        //     console.log(payload2)
        //     let pay = payload2.map(function (value: any) {
        //         const sh = payload.filter((a: any) => parseInt(a.so_no) === parseInt(value.so_no) && parseInt(a.sokoza_no) === parseInt(value.sokoza_no) && parseInt(a.bk_no) === parseInt(value.bk_no))
        //         if (sh[0]) {
        //             value.so_gak2 = parseInt(sh[0].so_gak)
        //             value.created_at = sh[0].created_at
        //             value.so_gak = parseInt(value.so_gak) ? (parseInt(value.so_gak) - (value.kjsh_gak ? parseInt(value.kjsh_gak) : 0) - (value.ftesu_gak ? parseInt(value.ftesu_gak) : 0)) : (0 - (value.kjsh_gak ? parseInt(value.kjsh_gak) : 0) - (value.ftesu_gak ? parseInt(value.ftesu_gak) : 0))
        //             value.sa = value.so_gak - value.so_gak2
        //             // value.so_gak2 = parseInt(sh[0].so_gak) ? (parseInt(sh[0].so_gak) - (sh[0].kjsh_gak ? parseInt(sh[0].kjsh_gak) : 0) - (sh[0].ftesu_gak ? parseInt(sh[0].ftesu_gak) : 0)) : (0 - (sh[0].kjsh_gak ? parseInt(sh[0].kjsh_gak) : 0) - (sh[0].ftesu_gak ? parseInt(sh[0].ftesu_gak) : 0))
        //         } else {
        //             value.so_gak = parseInt(value.so_gak) ? (parseInt(value.so_gak) - (value.kjsh_gak ? parseInt(value.kjsh_gak) : 0) - (value.ftesu_gak ? parseInt(value.ftesu_gak) : 0)) : (0 - (value.kjsh_gak ? parseInt(value.kjsh_gak) : 0) - (value.ftesu_gak ? parseInt(value.ftesu_gak) : 0))

        //             value.so_gak2 = 0
        //             value.sa = value.so_gak - value.so_gak2
        //         }
        //         return value
        //     })
        //     yield put(change_owner_remittance_check_logs(pay));
        //     if (state.RemittanceLogCheck.search_diff) {
        //         yield put(change_owner_remittance_check_logs_list(pay.filter((a: any) => a.sa !== 0)));
        //     } else {
        //         yield put(change_owner_remittance_check_logs_list(pay));
        //     }


        //     let owner_remittance_check_logs_sum = 0
        //     let so_ymd_list_sum = 0
        //     pay.map(function (value: any) {
        //         owner_remittance_check_logs_sum = owner_remittance_check_logs_sum + value.so_gak2
        //         so_ymd_list_sum = so_ymd_list_sum + value.so_gak
        //     })


        //     yield put(change_owner_remittance_check_logs_sum(owner_remittance_check_logs_sum));
        //     yield put(change_so_ymd_list_sum(so_ymd_list_sum));



        // } else {
        //     alert(error)
        //     //    // 失敗時アクション呼び出し
        //     //    yield put(loginFailure(payload));
        // }
        // // 成功時アクション呼び出し
        // // console.log(payload)
        // // let payloads = payload.map(function (value: any) {
        // //     // value.office_check_completed = value.office_check_completed_at ? true : false
        // //     value.office_check_completed = false
        // //     return value
        // // })
        // // alert()

        // yield put(change_search_loading(false))

    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}



// function* handle_get_so_ymd_list(action: any) {
//     const { payload, error } = yield call(sh_furi_api.soymdlist, action.payload);
//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         //
//         yield put(change_so_ymd_list(payload));


//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }

// }


// function* handle_net_checked(action: any) {
//     const state = yield select();

//     yield put(change_net_check_loading(action.payload));
//     let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
//     let s = rent_contracts_check_list.map(function (value: any) {
//         return { ...value, value }
//     })
//     yield put(change_rent_contracts_check_list(s));

//     const { payload, error } = yield call(rent_contracts_check_api.net, { rent_contract_id: action.payload });

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         // 成功時アクション呼び出し

//         let w = rent_contracts_check_list.map(function (value: any) {

//             if (value.id === action.payload) {
//                 value.office_check_net_user_name = payload.office_check_net_user_name
//                 value.office_check_net_at = payload.office_check_net_at
//                 value.office_check_net_user_name = payload.office_check_net_user_name
//                 return {
//                     ...value, value
//                 }
//             } else {
//                 return value
//             }
//         })
//         yield put(change_net_check_loading(0));
//         yield put(change_rent_contracts_check_list(w));


//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }

// }


// function* handle_energization_checked(action: any) {
//     const state = yield select();

//     yield put(change_energization_check_loading(action.payload));
//     let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
//     let s = rent_contracts_check_list.map(function (value: any) {
//         return { ...value, value }
//     })
//     yield put(change_rent_contracts_check_list(s));

//     const { payload, error } = yield call(rent_contracts_check_api.energization, { rent_contract_id: action.payload });

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         // 成功時アクション呼び出し

//         let w = rent_contracts_check_list.map(function (value: any) {

//             if (value.id === action.payload) {
//                 value.office_check_energization_user_name = payload.office_check_energization_user_name
//                 value.office_check_energization_at = payload.office_check_energization_at
//                 value.office_check_energization_user_name = payload.office_check_energization_user_name
//                 return {
//                     ...value, value
//                 }
//             } else {
//                 return value
//             }
//         })
//         yield put(change_energization_check_loading(0));
//         yield put(change_rent_contracts_check_list(w));


//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }

// }


// function* handle_electronics_checked(action: any) {
//     const state = yield select();

//     yield put(change_electronics_check_loading(action.payload));
//     let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
//     let s = rent_contracts_check_list.map(function (value: any) {
//         return { ...value, value }
//     })
//     yield put(change_rent_contracts_check_list(s));

//     const { payload, error } = yield call(rent_contracts_check_api.electronics, { rent_contract_id: action.payload });

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         // 成功時アクション呼び出し

//         let w = rent_contracts_check_list.map(function (value: any) {

//             if (value.id === action.payload) {
//                 value.office_check_electronics_user_name = payload.office_check_electronics_user_name
//                 value.office_check_electronics_at = payload.office_check_electronics_at
//                 value.office_check_electronics_user_name = payload.office_check_electronics_user_name
//                 return {
//                     ...value, value
//                 }
//             } else {
//                 return value
//             }
//         })
//         yield put(change_electronics_check_loading(0));
//         yield put(change_rent_contracts_check_list(w));


//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }

// }


// function* handle_wifi_checked(action: any) {
//     const state = yield select();

//     yield put(change_wifi_check_loading(action.payload));
//     let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
//     let s = rent_contracts_check_list.map(function (value: any) {
//         return { ...value, value }
//     })
//     yield put(change_rent_contracts_check_list(s));

//     const { payload, error } = yield call(rent_contracts_check_api.wifi, { rent_contract_id: action.payload });

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         // 成功時アクション呼び出し

//         let w = rent_contracts_check_list.map(function (value: any) {

//             if (value.id === action.payload) {
//                 value.office_check_wifi_user_name = payload.office_check_wifi_user_name
//                 value.office_check_wifi_at = payload.office_check_wifi_at
//                 value.office_check_wifi_user_name = payload.office_check_wifi_user_name
//                 return {
//                     ...value, value
//                 }
//             } else {
//                 return value
//             }
//         })
//         yield put(change_wifi_check_loading(0));
//         yield put(change_rent_contracts_check_list(w));


//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }

// }

// function* handle_owner_tel_checked(action: any) {
//     const state = yield select();

//     yield put(change_owner_tel_check_loading(action.payload));
//     let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
//     let s = rent_contracts_check_list.map(function (value: any) {
//         return { ...value, value }
//     })
//     yield put(change_rent_contracts_check_list(s));

//     const { payload, error } = yield call(rent_contracts_check_api.owner_tel, { rent_contract_id: action.payload });

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         // 成功時アクション呼び出し

//         let w = rent_contracts_check_list.map(function (value: any) {

//             if (value.id === action.payload) {
//                 value.office_check_owner_tel_user_name = payload.office_check_owner_tel_user_name
//                 value.office_check_owner_tel_at = payload.office_check_owner_tel_at
//                 value.office_check_owner_tel_user_name = payload.office_check_owner_tel_user_name
//                 return {
//                     ...value, value
//                 }
//             } else {
//                 return value
//             }
//         })
//         yield put(change_owner_tel_check_loading(0));
//         yield put(change_rent_contracts_check_list(w));


//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }

// }



// function* handle_completed_checked(action: any) {
//     const state = yield select();


//     let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
//     let s = rent_contracts_check_list.map(function (value: any) {
//         if (value.id === action.payload) {
//             value.office_check_completed = !value.office_check_completed
//             return { ...value, value }
//         } else {
//             return value
//         }
//     })
//     yield put(change_rent_contracts_check_list(s));



// }


// function* handle_all_selected(action: any) {
//     const state = yield select();


//     let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
//     let s = rent_contracts_check_list.map(function (value: any) {

//         value.office_check_completed = action.payload
//         return { ...value, value }

//     })
//     yield put(change_rent_contracts_check_list(s));



// }



// function* handle_check_completed(action: any) {
//     const state = yield select();

//     yield put(change_search_loading(true))
//     let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list.filter((a: any) => a.office_check_completed === true)
//     // let s = rent_contracts_check_list.map(function (value: any) {
//     //     return { ...value, value }
//     // })
//     // yield put(change_rent_contracts_check_list(s));

//     const { payload, error } = yield call(rent_contracts_check_api.check_completed, rent_contracts_check_list);

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         // 成功時アクション呼び出し


//         yield put(get_rent_contracts_check_list(payload));


//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }

// }


// function* handle_check_completed_cancel(action: any) {
//     const state = yield select();

//     yield put(change_search_loading(true))
//     let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list.filter((a: any) => a.office_check_completed === true)
//     // let s = rent_contracts_check_list.map(function (value: any) {
//     //     return { ...value, value }
//     // })
//     // yield put(change_rent_contracts_check_list(s));

//     const { payload, error } = yield call(rent_contracts_check_api.check_completed_cancel, rent_contracts_check_list);

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         // 成功時アクション呼び出し


//         yield put(get_rent_contracts_check_list(payload));


//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }

// }

